import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { getMe } from '../services/LoginServices';
import { getRamos } from '../services/RamosServices';
import { getRubros } from '../services/RubrosServices';
import { getSubrubros } from '../services/SubrubrosServices';
import { getEmpresa } from '../services/EmpresaServices';
import { getCarritoByUserID, postItemCarrito } from '../services/CarritoServices';
import { generateRandomString } from '../utils/randomString';
import { useNavigate } from 'react-router-dom';


export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [name, setName] = useState(localStorage.getItem('name') || null);
  const [ramos, setRamos] = useState(null);
  const [rubros, setRubros] = useState(null);
  const [subrubros, setSubrubros] = useState(null);
  const [empresa, setEmpresa] = useState(null);
  const [clienteSelected, setClienteSelected] = useState(() => {
    const cliente = localStorage.getItem('clienteSelected');
    return cliente ? JSON.parse(cliente) : null;
  });
  const [forceModalOpen, setForceModalOpen] = useState(false);
  const [showClientes, setShowClientes] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const [idCarrito, setIdCarrito] = useState(localStorage.getItem('idCarrito'));
  const [cartItems, setCartItems] = useState([]);

  const EXPIRATION_TIME = 15 * 60 * 1000;

  const isDataExpired = (timestampKey) => {
    const timestamp = localStorage.getItem(timestampKey);
    return !timestamp || Date.now() - parseInt(timestamp, 10) > EXPIRATION_TIME;
  };

  // Verifica expiración del token
  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 < Date.now()) {
          logout();
        } else {
          setIsAuthenticated(true);
        }
      } catch (err) {
        logout();
      }
    }
  }, [token]);

  // Inicializa datos
  useEffect(() => {
    getRamosData();
    getRubrosData();
    getSubrubrosData();
    getEmpresaData();

    if (user) {
      if (user.rol_id === 1) {
        setShowClientes(true);
        if (!clienteSelected) {
          setForceModalOpen(true);
        }
      } else {
        setShowClientes(false);
      }
    } else {
      setShowClientes(false);
      if (!localStorage.getItem('clienteTemp')) {
        localStorage.setItem('clienteTemp', "id_" + generateRandomString());
      }
    }
  }, []);

  // Muestra empresa cuando cambia
  useEffect(() => {
    if (empresa) {
      //console.log("Empresa actualizada:");
    }
  }, [empresa]);

  const getRamosData = async () => {
    const local = localStorage.getItem('ramos');
    if (local && !isDataExpired('ramos_timestamp')) {
      setRamos(JSON.parse(local));
    } else {
      try {
        const data = await getRamos();
        setRamos(data);
        localStorage.setItem('ramos', JSON.stringify(data));
        localStorage.setItem('ramos_timestamp', Date.now().toString());
      } catch (error) {
        console.error("Error al obtener ramos:", error);
      }
    }
  };

  const getRubrosData = async () => {
    const local = localStorage.getItem('rubros');
    if (local && !isDataExpired('rubros_timestamp')) {
      setRubros(JSON.parse(local));
    } else {
      try {
        const data = await getRubros();
        setRubros(data);
        localStorage.setItem('rubros', JSON.stringify(data));
        localStorage.setItem('rubros_timestamp', Date.now().toString());
      } catch (error) {
        console.error("Error al obtener rubros:", error);
      }
    }
  };

  const getSubrubrosData = async () => {
    const local = localStorage.getItem('subrubros');
    if (local && !isDataExpired('subrubros_timestamp')) {
      setSubrubros(JSON.parse(local));
    } else {
      try {
        const data = await getSubrubros();
        setSubrubros(data);
        localStorage.setItem('subrubros', JSON.stringify(data));
        localStorage.setItem('subrubros_timestamp', Date.now().toString());
      } catch (error) {
        console.error("Error al obtener subrubros:", error);
      }
    }
  };

  const getEmpresaData = async () => {
    try {
      const data = await getEmpresa();
      setEmpresa(data);
      localStorage.setItem('empresa', JSON.stringify(data));
      localStorage.setItem('empresa_timestamp', Date.now().toString());
    } catch (error) {
      console.error("Error al obtener empresa:", error);
    }
  };

  const getMeData = async () => {
    try {
      const userMe = await getMe();
      console.log("user",userMe)
      if (userMe) {
        setUser(userMe);
        localStorage.setItem('user', JSON.stringify(userMe));
        setName(userMe?.sel_username);
        localStorage.setItem('name', userMe?.sel_username);

        if (userMe.rol_id === 1) {
          setShowClientes(true);
          if (userMe.empleadoUser) {
            localStorage.setItem('clientes', JSON.stringify(userMe.empleadoUser));
          }
        } else {
          const result = await getCarritoByUserID(userMe.id, true);
          if (result?.id) {
            localStorage.setItem('idCarrito', result.id);
            setIdCarrito(result.id);
          }
        }

        localStorage.removeItem('clienteTemp');
      }
    } catch (error) {
      console.error("Error en getMeData:", error);
    }
  };

  const login = async () => {
    const accessToken = localStorage.getItem('token');
    if (accessToken) {
      try {
        jwtDecode(accessToken);
        setToken(accessToken);
        setIsAuthenticated(true);
        await getMeData();
      } catch (err) {
        logout();
      }
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    setName(null);
    setClienteSelected(null);
    setIsAuthenticated(false);
    setShowClientes(false);
    setForceModalOpen(false);
    setIdCarrito(null);
    localStorage.clear();
    navigate('/');
  };

  const addToCart = async (productID, amount, observation) => {
    let userID;
    let isLogin = false;
    let idCarritoAux = idCarrito;
console.log("producto ", productID ,"porpor ", amount)
    if (user) {
      if (user.rol_id === 1 && !clienteSelected) {
        setForceModalOpen(true);
        return;
      }

      userID = user.rol_id === 1 ? clienteSelected?.id : user.id;
      isLogin = true;
    } else {
      navigate('/login');
      return;
    }

    if (!idCarrito) {
      try {
        const result = await getCarritoByUserID(userID, isLogin);
        if (result?.id) {
          localStorage.setItem("idCarrito", result.id);
          setIdCarrito(result.id);
          idCarritoAux = result.id;
        } else {
          console.error("No se encontró carrito.");
          return;
        }
      } catch (err) {
        console.error("Error obteniendo carrito:", err);
        return;
      }
    }

    const item = {
      cart_id: idCarritoAux,
      art_Id: productID,
      cantidad: amount,
      observacion: observation,
    };

    try {
      await postItemCarrito(item);
    } catch (err) {
      console.error("Error agregando al carrito:", err);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        name,
        user,
        isAuthenticated,
        login,
        logout,
        forceModalOpen,
        showClientes,
        clienteSelected,
        setClienteSelected,
        setForceModalOpen,
        ramos,
        rubros,
        subrubros,
        empresa,
        setIdCarrito,
        getMeData,
        addToCart,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
